
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, AuthLoadingScreen } from "@/context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  useEffect(() => {
    // Wait until auth state is resolved, then redirect
    if (!isLoading) {
      navigate(user ? '/' : '/auth', { replace: true });
    }
  }, [user, isLoading, navigate]);

  return (
    <div className="h-screen flex flex-col items-center justify-center">
      <AuthLoadingScreen />
      <p className="mt-8 text-muted-foreground">
        Completing authentication, please wait...
      </p>
    </div>
  );
};

export default AuthCallback;
